/* esm.sh - applesauce-core@5.2.0/dist/helpers/cache */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/cache.mjs";
